import {IRange} from "@pg-design/inputs-module";

import {ISearchFilterSlot} from "../../types/ISearchFilters";
import {SearchFilterTypes} from "../../types/SearchFilterTypes";

export const rooms: ISearchFilterSlot<"rooms", IRange<number>> = {
    id: "rooms",
    label: "Pokoje",
    filters: [
        {
            id: "rooms",
            type: SearchFilterTypes.SELECT_RANGE,
            filterOptions: [
                {
                    id: "1",
                    label: "1",
                    value: 1
                },
                {
                    id: "2",
                    label: "2",
                    value: 2
                },
                {
                    id: "3",
                    label: "3",
                    value: 3
                },
                {
                    id: "4",
                    label: "4",
                    value: 4
                },
                {
                    id: "5",
                    label: "5+",
                    value: 5
                }
            ]
        }
    ]
};
import {IRange} from "@pg-design/inputs-module";

import {ISearchFilterSlot} from "../../types/ISearchFilters";
import {SearchFilterTypes} from "../../types/SearchFilterTypes";

export const rooms: ISearchFilterSlot<"rooms", IRange<number>> = {
    id: "rooms",
    label: "Pokoje",
    filters: [
        {
            id: "rooms",
            type: SearchFilterTypes.SELECT_RANGE,
            filterOptions: [
                {
                    id: "1",
                    label: "1",
                    value: 1
                },
                {
                    id: "2",
                    label: "2",
                    value: 2
                },
                {
                    id: "3",
                    label: "3",
                    value: 3
                },
                {
                    id: "4",
                    label: "4",
                    value: 4
                },
                {
                    id: "5",
                    label: "5+",
                    value: 5
                }
            ]
        }
    ]
};
